/*
 * @Author: huxg 9506976+huxgs521@user.noreply.gitee.com
 * @Date: 2023-11-27 11:09:33
 * @LastEditors: weixin_44214515 weixin_44214515@noreply.gitcode.com
 * @LastEditTime: 2024-09-14 17:03:31
 * @FilePath: /front-vps-admin/src/public/store/modules/site.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import SiteAPI from "@/web-framework/api/site.js";
const state = {
    siteInfo: {},
};

const mutations = {
    SET_SITE_INFO: (state, siteInfo) => {
        state.siteInfo = siteInfo;
    }
};

const actions = {
    // 获取站点信息
    loadSiteInfo({ commit }) {
        return new Promise((resolve, reject) => {
            SiteAPI.currentSiteInfo().then(result => {
                if (result.success) {
                    commit("SET_SITE_INFO", result.data || {});
                }
                resolve();
            }).catch(error => {
                reject(error);
            });
        });
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};